import {
  EditBlockTextInput,
  EditBlockColorPicker,
  EditBlockSelect,
  EditBlockSwitch,
  EditBlockNumericInput,
  EditBlockSliderInput,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'

export default {
  name: 'FieldEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-text-input': EditBlockTextInput,
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-select': EditBlockSelect,
    'edit-block-switch': EditBlockSwitch,
    'edit-block-numeric-input': EditBlockNumericInput,
    'edit-block-slider-input': EditBlockSliderInput,
  },
  data() {
    return {}
  },
  computed: {
    fieldPlaceholderText: {
      get() {
        return this.component.content.placeholder
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['content'],
          attribute: ['placeholder'],
          data: value,
        })
      },
    },
    //= ============== STYLING
    fieldFontFamily: {
      get() {
        return this.component.styling.fontFamily
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontFamily'],
          data: value,
        })
      },
    },
    fieldFontColor: {
      get() {
        return this.component.styling.color
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['color'],
          data: value,
        })
      },
    },
    fieldBackgroundColor: {
      get() {
        return this.component.styling.backgroundColor
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['backgroundColor'],
          data: value,
        })
      },
    },
    fieldBorderWidth: {
      get() {
        // Removes 'px' from string
        return parseInt(this.component.styling.borderWidth, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderWidth'],
          data: value + 'px',
        })
      },
    },
    fieldBorderRadius: {
      get() {
        return parseInt(this.component.styling.borderRadius, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderRadius'],
          data: value + 'px',
        })
      },
    },
    fieldBorderColor: {
      get() {
        return this.component.styling.borderColor
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderColor'],
          data: value,
        })
      },
    },
    fieldFontSize: {
      get() {
        return this.component.styling.fontSize
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontSize'],
          data: value,
        })
      },
    },
    fieldTextAlign: {
      get() {
        return this.component.styling.textAlign
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['textAlign'],
          data: value,
        })
      },
    },
    //= ============== SETTINGS
    fieldLabel: {
      get() {
        return this.component.settings.label
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['label'],
          data: value,
        })
      },
    },
    fieldType: {
      get() {
        return this.component.settings.type
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['type'],
          data: value,
        })
      },
    },
    fieldRequired: {
      get() {
        return this.component.settings.required
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['required'],
          data: value,
        })
      },
    },
  },
}
